<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"

  type Props = {
    submitting?: boolean
    saveDisabled?: boolean
    onCancel: () => void
    onSave: () => void | Promise<void>
  }

  const { submitting = false, saveDisabled = false, onCancel, onSave }: Props = $props()
</script>

<CTA type="secondaryButton" content="Abbrechen" onClick={onCancel} disabled={submitting} />
<CTA
  type="primaryButton"
  content={submitting ? "Speichere..." : "Speichern"}
  onClick={onSave}
  disabled={submitting || saveDisabled}
/>
